export const documentTypes = [
  { value: 'ANALI', displayName: 'Analitika' },
  { value: 'ELEKT', displayName: 'Elektronikus' },
  { value: 'SART', displayName: 'Folyóiratcikk' },
  { value: 'SISS', displayName: 'Füzet' },
  { value: 'SREC', displayName: 'Hangfelvétel' },
  { value: 'SER', displayName: 'Időszaki kiadvány' },
  { value: 'CHAP', displayName: 'Könyv fejezet' },
  { value: 'BKM', displayName: 'Könyv/monográfia' },
  { value: 'VOL', displayName: 'Kötet' },
  { value: 'BVOL', displayName: 'Kötött évfolyam' },
  { value: 'VREC', displayName: 'Mozgókép, film' },
  { value: 'NONC', displayName: 'Nem katalogizált' },
  { value: 'CART', displayName: 'Térképészeti anyag' },
  { value: 'MVOL', displayName: 'Többkötetes' },

  { value: 'ADATB', displayName: 'Adatbázis' },
  { value: 'ADATW', displayName: 'adatbázis/www' },
  { value: 'AUDIO', displayName: 'audiocd' },
  { value: 'AUDHA', displayName: 'audiocd/hangfelvétel' },
  { value: 'AUDKO', displayName: 'audiocd/kötet' },
  { value: 'AUDIT', displayName: 'audiocd/többkötetes' },
  { value: 'AUDZE', displayName: 'audiocd/zenei mű' },
  { value: 'BR', displayName: 'Blu-Ray' },
  { value: 'CD', displayName: 'CD' },
  { value: 'CDHA', displayName: 'CD/hangfelvétel' },
  { value: 'CDKOT', displayName: 'CD/kötet' },
  { value: 'CDSO', displayName: 'CD/sorozat' },
  { value: 'CDTK', displayName: 'CD/többkötetes' },
  { value: 'CDZEN', displayName: 'CD/zenei mű' },
  { value: 'STAT', displayName: 'cikk/statisztika' },
  { value: 'TANUL', displayName: 'cikk/tanulmány' },
  { value: 'TEXTP', displayName: 'cikk/textpac' },
  { value: 'DVD', displayName: 'DVD' },
  { value: 'DVDM', displayName: 'DVD/film' },
  { value: 'DVDH', displayName: 'DVD/hangfelvétel' },
  { value: 'DVDK', displayName: 'DVD/kötet' },
  { value: 'DVDS', displayName: 'DVD/sorozat' },
  { value: 'DVDT', displayName: 'DVD/többkötetes' },
  { value: 'DVDZ', displayName: 'DVD/zenei mű' },
  { value: 'FLOP', displayName: 'flopi' },
  { value: 'FLOPK', displayName: 'flopi/könyv' },
  { value: 'FLOPO', displayName: 'flopi/kötet' },
  { value: 'FLOPT', displayName: 'flopi/többkötetes' },
  { value: 'HGKV', displayName: 'hangoskönyv' },
  { value: 'HGKVK', displayName: 'hangoskönyv/kötet' },
  { value: 'HGKVT', displayName: 'hangoskönyv/többkötetes' },
  { value: 'BRI', displayName: 'időszaki/Blu-Ray' },
  { value: 'BRF', displayName: 'időszaki/Blu-Ray (füzet)' },
  { value: 'CDI', displayName: 'időszaki/CD' },
  { value: 'CDF', displayName: 'időszaki/CD (füzet)' },
  { value: 'DVDI', displayName: 'időszaki/DVD' },
  { value: 'DVDF', displayName: 'időszaki/DVD (füzet)' },
  { value: 'IDOSZ', displayName: 'időszaki/évkönyv' },
  { value: 'IDOF', displayName: 'időszaki/évkönyv (füzet)' },
  { value: 'IDOSS', displayName: 'időszaki/évkönyv (sorozat)' },
  { value: 'FLOPI', displayName: 'időszaki/flopi' },
  { value: 'FLOPF', displayName: 'időszaki/flopi (füzet)' },
  { value: 'FIRAT', displayName: 'időszaki/folyóirat' },
  { value: 'FIRC', displayName: 'időszaki/folyóirat (füzet)' },
  { value: 'FIRF', displayName: 'időszaki/folyóirat (kötött évf.)' },
  { value: 'FOLS', displayName: 'időszaki/folyóirat (sorozat)' },
  { value: 'MFILI', displayName: 'időszaki/mikrofilm' },
  { value: 'JEGYZ', displayName: 'jegyzet' },
  { value: 'JEGYK', displayName: 'jegyzet/kötet' },
  { value: 'JEGYT', displayName: 'jegyzet/többkötetes' },
  { value: 'KATAL', displayName: 'katalógus/csak gyarapítás' },
  { value: 'KEZIR', displayName: 'kézirat' },
  { value: 'KEZIK', displayName: 'kézirat/kötet' },
  { value: 'KEZIT', displayName: 'kézirat/többkötetes' },
  { value: 'KONYV', displayName: 'könyv' },
  { value: 'KONYK', displayName: 'könyv/kötet' },
  { value: 'SORK', displayName: 'könyv/sorozat' },
  { value: 'KTAN', displayName: 'könyv/tanulmány' },
  { value: 'KTAC', displayName: 'könyv/tanulmány (fejezet)' },
  { value: 'KONYT', displayName: 'könyv/többkötetes' },
  { value: 'MFILM', displayName: 'mikrofilm' },
  { value: 'MFIF', displayName: 'mikrofilm/füzet' },
  { value: 'MFID', displayName: 'mikrofilm/időszaki' },
  { value: 'MFIK', displayName: 'mikrofilm/kötet' },
  { value: 'MFILT', displayName: 'mikrofilm/többkötetes' },
  { value: 'NGY', displayName: 'nem gyűjtött folyóirat' },
  { value: 'TERK', displayName: 'térkép' },
  { value: 'TERKK', displayName: 'térkép/kötet' },
  { value: 'TERS', displayName: 'térkép/sorozat' },
  { value: 'TERKT', displayName: 'térkép/többkötetes' },
  { value: 'VIDEO', displayName: 'videokazetta' },
];
